"use strict";
import { useMemo } from "react";
import { OnchainItemListOptionType } from "components/lists/items/types";
import {
  Chain
} from "data/graphql/uniswap-data-api/__generated__/types-and-hooks";
import { fromGraphQLChain } from "features/chains/utils";
function gqlNFTToNFTCollectionOption(node) {
  const contract = node?.nftContracts?.[0];
  const chainId = fromGraphQLChain(contract?.chain ?? Chain.Ethereum);
  if (node.name && contract?.address && chainId) {
    return {
      type: OnchainItemListOptionType.NFTCollection,
      chainId,
      address: contract.address,
      name: node.name,
      imageUrl: node?.image?.url ?? null,
      isVerified: Boolean(node.isVerified)
    };
  }
  return null;
}
export function useNftSearchResultsToNftCollectionOptions(nftSearchResultsData, chainFilter) {
  return useMemo(() => {
    const collections = nftSearchResultsData ? "nftCollections" in nftSearchResultsData ? nftSearchResultsData.nftCollections : nftSearchResultsData?.topCollections : void 0;
    if (!collections) {
      return [];
    }
    return collections.edges.reduce((acc, { node }) => {
      const option = gqlNFTToNFTCollectionOption(node);
      if (option && (chainFilter === null || option.chainId === chainFilter)) {
        acc.push(option);
      }
      return acc;
    }, []);
  }, [nftSearchResultsData, chainFilter]);
}
